import { twMerge } from "tailwind-merge";
import { type ClassValue, clsx } from "clsx";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Wrapper für fetch mit deutschen Logs während des Builds
 */
export async function fetchWithLogging(
    url: string | URL,
    options?: RequestInit,
): Promise<Response> {
    // Aktiviere Logging während des Builds (production build oder wenn NEXT_PHASE gesetzt ist)
    const isBuildTime =
        process.env.NEXT_PHASE === "phase-production-build" ||
        process.env.NEXT_PHASE === "phase-development-build" ||
        (process.env.NODE_ENV === "production" && typeof window === "undefined");

    if (isBuildTime) {
        const method = options?.method || "GET";
        const urlString = typeof url === "string" ? url : url.toString();
        console.log(`[Build] ${method} Request: ${urlString}`);

        const startTime = Date.now();
        try {
            const response = await fetch(url, options);
            const duration = Date.now() - startTime;

            if (response.ok) {
                console.log(`[Build] ✓ Erfolgreich: ${method} ${urlString} (${duration}ms)`);
            } else {
                console.log(
                    `[Build] ✗ Fehler: ${method} ${urlString} - Status: ${response.status} (${duration}ms)`,
                );
            }

            return response;
        } catch (error) {
            const duration = Date.now() - startTime;
            console.log(`[Build] ✗ Fehler beim Request: ${method} ${urlString} (${duration}ms)`);
            console.error(`[Build] Fehlerdetails:`, error);
            throw error;
        }
    }

    // Während der Entwicklung (dev server) normalen fetch verwenden
    return fetch(url, options);
}
